/* tslint:disable */

declare var Object: any;
export interface MarketplaceAccessInterface {
  "id"?: number;
}

export class MarketplaceAccess implements MarketplaceAccessInterface {
  "id": number;
  constructor(data?: MarketplaceAccessInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MarketplaceAccess`.
   */
  public static getModelName() {
    return "MarketplaceAccess";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MarketplaceAccess for dynamic purposes.
  **/
  public static factory(data: MarketplaceAccessInterface): MarketplaceAccess{
    return new MarketplaceAccess(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MarketplaceAccess',
      plural: 'MarketplaceAccesses',
      path: 'MarketplaceAccesses',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/MarketplaceAccess.ts